var OfficeFilter;
(function (OfficeFilter) {
    OfficeFilter["PATIENTS"] = "patients";
    OfficeFilter["PRESCRIBERS"] = "prescriber";
})(OfficeFilter || (OfficeFilter = {}));
var CurrentPastFilter;
(function (CurrentPastFilter) {
    CurrentPastFilter["CURRENT"] = "current";
    CurrentPastFilter["PAST"] = "past";
    CurrentPastFilter["ALL"] = "all";
})(CurrentPastFilter || (CurrentPastFilter = {}));
var ActionRequiredFilter;
(function (ActionRequiredFilter) {
    ActionRequiredFilter["ACTION_REQUIRED"] = "action required";
    ActionRequiredFilter["NO_ACTION_REQUIRED"] = "no action required";
    ActionRequiredFilter["ALL"] = "all";
})(ActionRequiredFilter || (ActionRequiredFilter = {}));
var StatusFilter;
(function (StatusFilter) {
    StatusFilter["PENDING_SCHEDULING"] = "pending scheduling";
    StatusFilter["SCHEDULED"] = "scheduled";
    StatusFilter["IN_ITINERARY"] = "in itinerary";
    StatusFilter["COMPLETE"] = "complete";
    StatusFilter["CANCELED"] = "canceled";
})(StatusFilter || (StatusFilter = {}));
var StatusFilterType;
(function (StatusFilterType) {
    StatusFilterType["DRAFT"] = "draft";
    StatusFilterType["WAYPOINT"] = "waypoint";
    StatusFilterType["ALL"] = "all";
})(StatusFilterType || (StatusFilterType = {}));

export { ActionRequiredFilter, CurrentPastFilter, OfficeFilter, StatusFilter, StatusFilterType };
